"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZeroResult = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const context_1 = require("../context");
const constants_1 = require("../constants");
const ZeroResult = () => {
    const { tiles, isTabZeroResult, isZeroResult, isHitsAndFiltersLoading, selectedTab: { key }, configData: { zeroResultMessage }, } = (0, context_1.useSearchResultContext)();
    if (isZeroResult || !isTabZeroResult || isHitsAndFiltersLoading || (tiles === null || tiles === void 0 ? void 0 : tiles.length) > 0) {
        return null;
    }
    const iconName = constants_1.ICON_BY_TAB_KEY_MAP[key];
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex items-center justify-center", children: [(0, jsx_runtime_1.jsxs)("div", { className: "max-w-[530px] pr-6 text-left", children: [(0, jsx_runtime_1.jsx)("h2", { className: "mb-4 sm:mb-8", children: zeroResultMessage === null || zeroResultMessage === void 0 ? void 0 : zeroResultMessage.title }), (0, jsx_runtime_1.jsx)("div", { className: "prose prose-danfoss", children: (0, app_1.StringToHTML)(zeroResultMessage === null || zeroResultMessage === void 0 ? void 0 : zeroResultMessage.description) })] }), (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: iconName, className: "text-[120px] opacity-35" })] }));
};
exports.ZeroResult = ZeroResult;
